import PropTypes from 'prop-types';
import { equals } from 'ramda';
import React from 'react';
import { connect } from 'react-redux';

import Edit from '@material-ui/icons/Edit';
import Fab from '@material-ui/core/Fab';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import { openLeftBarModule } from '../../modules/actions/layout';
import { makeGetActiveSubcontractorFromCompany } from './selectors';


const activeSubcontractorName = (activeSubcontractor) => {
  if (activeSubcontractor) {
    if (equals(activeSubcontractor.attributes['first-name'], '') &&
        equals(activeSubcontractor.attributes['last-name'], ''))
      return (<em>Verborgen</em>);

    return (<em>{`${activeSubcontractor.attributes['first-name']} ${activeSubcontractor.attributes['last-name']}`}</em>)
  }

  return (<em>Niemand actief!</em>);
};

const CompanyRow = ({ activeSubcontractor, company, openLeftBarModule }) => (
  <TableRow>
    <TableCell>
      {company.attributes.name}
      <br />
      {activeSubcontractorName(activeSubcontractor)}
    </TableCell>

    <TableCell>
      {company.attributes.address}
      <br />
      {company.attributes.zipcode}
      <br />
      {company.attributes.city}
    </TableCell>

    <TableCell>
      {company.attributes.phone}
      <br />
      {company.attributes['phone-24h']}
      <br />
      {company.attributes['phone-24h-2']}
      <br />
      {company.attributes.email}
    </TableCell>

    <TableCell>
      <div onClick={() => openLeftBarModule('company', 'companyEdit', { id: company.id })}>
        <Fab color="primary" aria-label="edit" size="small">
          <Edit />
        </Fab>
      </div>
    </TableCell>
  </TableRow>
);

CompanyRow.propTypes = {
  // own props
  company: PropTypes.shape({
    id: PropTypes.string.isRequired,

    attributes: PropTypes.shape({
      address: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      phone: PropTypes.string.isRequired,
      'phone-24h': PropTypes.string.isRequired,
      'phone-24h-2': PropTypes.string,
      zipcode: PropTypes.string.isRequired,
    }).isRequired,

    relationships: PropTypes.shape({
      'active-subcontractor': PropTypes.shape({
        data: PropTypes.shape({
          id: PropTypes.string.isRequired,
        }),
      }).isRequired,
    }).isRequired,
  }).isRequired,

  // state props
  activeSubcontractor: PropTypes.shape({
    attributes: PropTypes.shape({
      'first-name': PropTypes.string.isRequired,
      'last-name': PropTypes.string.isRequired,
    }).isRequired,
  }),

  // dispatch props
  openLeftBarModule: PropTypes.func.isRequired,
};

CompanyRow.defaultProps = {
  activeSubcontractor: undefined,
};

const makeMapStateToProps = () => {
  const getActiveSubcontractorFromCompany = makeGetActiveSubcontractorFromCompany();

  return (state, ownProps) => ({
    activeSubcontractor: getActiveSubcontractorFromCompany(state, ownProps),
  });
};

export default connect(makeMapStateToProps, { openLeftBarModule })(CompanyRow);
